const Feedback = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Feedback</h1>
      <p className="text-lg mb-4">
        Share your thoughts and suggestions with us.
      </p>
    </div>
  );
};

export default Feedback; 